import Resource from '@/api/core/resource'
import appConfig from '@/config/appConfig'

class Estudio extends Resource {
  constructor () {
    super('estudios')
  }

  obtenerUrlSubirArchivo (data) {
    return appConfig.urlApi.concat(
      this.uri
        .concat('/subir-archivo')
    )
  }

  obtenerUrlSubirOrden (data) {
    return appConfig.urlApi.concat(
      this.uri
        .concat('/subir-orden')
    )
  }

  descargar (archivoId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(archivoId)
          .concat('/descargar')
      )
    )
  }

  descargarOrden (archivoId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(archivoId)
          .concat('/descargar-orden')
      )
    )
  }
}

export default new Estudio()
